import { useState } from 'react';

const INITIAL_FORM = { name: '', email: '', phone: '', subject: '', message: '' };

export function useContactForm() {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await response.json();

      if (response.ok) {
        setSubmitStatus({ type: 'success', message: data.message });
        setFormData(INITIAL_FORM);
      } else {
        setSubmitStatus({ type: 'error', message: data.detail || 'Failed to send message. Please try again.' });
      }
    } catch {
      setSubmitStatus({ type: 'error', message: 'Failed to send message. Please email us directly at info@flyfinder.ca' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return { formData, isSubmitting, submitStatus, handleChange, handleSubmit };
}
